import { ref } from 'vue';
import { defineStore } from 'pinia';
import Order from '@/entity/Order';
import { fulfillmentService } from '@/services';
import orderService from '@/services/order';
import { ServiceDataOrderEvent } from '@/service-data/order-event/ServiceDataOrderEvent';
import { orderEvent } from '@/constants';
/** 초기화 (reset) 안할 데이터는 이곳에 추가 */
export const prevData = {};
// pinia 라이더 배차 다이얼로그
export const piniaWorkerAllocate = defineStore('workerAllocate', () => {
    // INIT
    // STATE
    /** 선택한 주문의 아이디 */
    const orderId = ref('');
    /** 팝업을 연 총판 아이디 */
    const distId = ref('');
    /** 팝업을 연 허브 아이디 */
    const hubId = ref('');
    /** 주문 */
    const selectedOrder = ref(undefined);
    /** 풀필먼트 */
    const fulfillment = ref(undefined);
    /** 배차 다이얼로그 열기 여부 */
    const isDialogOpen = ref(false);
    /** 선택한 라이더 */
    const selectedWorker = ref(undefined);
    /** 선택한 라이더의 주문 리스트 */
    const selectedWorkerOrderList = ref([]);
    /** 허브 리스트 */
    const hubList = ref([]);
    /** 검색 */
    const filterOption = ref({
        selectedHub: {
            type: 'HUB',
            id: 'ALL',
            hubId: 'ALL',
            hubName: '전체',
        },
        searchText: '',
    });
    /** 검색 필터 적용된 리스트 */
    const filteredItemList = ref([]);
    // GETTER
    // METHOD
    /**
     * 총판, 허브 아이디 셋팅
     */
    const setPopupData = (config) => {
        distId.value = config.distId || '';
        hubId.value = config.hubId || '';
        orderId.value = config.orderId || '';
    };
    /**
     * 주문 조회
     */
    const getOrder = async () => {
        const res = await orderService.getOrder({
            orderId: orderId.value,
        });
        selectedOrder.value = new Order(res.data);
    };
    /**
     * 검색 필터 적용된 리스트 셋팅
     * + 선택 라이더 해제
     */
    const updateFilteredItemList = () => {
        selectedWorker.value = undefined;
        filteredItemList.value = fulfillment.value?.filter((_item) => {
            // 1. 전체 + 전체
            if (filterOption.value.selectedHub.id === 'ALL'
                && filterOption.value.searchText === '') {
                return true;
            }
            // 2. 전체 + 라이더
            if (filterOption.value.selectedHub.id === 'ALL'
                && _item.workerName.includes(filterOption.value.searchText)) {
                return true;
            }
            // 3. 허브 + 전체
            if (filterOption.value.selectedHub.id === _item.hubId
                && filterOption.value.searchText === '') {
                return true;
            }
            // 4. 허브 + 라이더
            if (filterOption.value.selectedHub.id === _item.hubId
                && _item.workerName.includes(filterOption.value.searchText)) {
                return true;
            }
            return false;
        }) ?? [];
    };
    /**
     * 풀필먼트 조회
     */
    const getFulfillment = async () => {
        const response = await fulfillmentService.getAllocatableWorker(orderId.value);
        fulfillment.value = response?.map((item) => (Object.assign(item, {
            distanceCustomer: item.getDistanceCustomer({
                dropLat: Number(selectedOrder.value?.dropLatitude),
                dropLong: Number(selectedOrder.value?.dropLongitude),
            }),
        })));
        updateFilteredItemList();
    };
    /**
     * 배차 이벤트
     */
    const actionAllocate = (type) => {
        const _orderId = selectedOrder.value.orderId;
        const { workerCode } = selectedWorker.value;
        const serviceData = new ServiceDataOrderEvent({
            orderId: _orderId,
            workerCode,
        });
        if (type === orderEvent.WORKER_REQUEST) {
            return orderService.workerRequest(serviceData);
        }
        if (type === orderEvent.ALLOCATE) {
            return orderService.allocate(serviceData);
        }
        if (type === orderEvent.REALLOCATE) {
            return orderService.reallocate(serviceData);
        }
        return '';
    };
    /**
     * 배차 요청
     */
    const allocateRequest = () => {
        const _orderId = selectedOrder.value.orderId;
        const { workerCode } = selectedWorker.value;
        const serviceData = new ServiceDataOrderEvent({
            orderId: _orderId,
            workerCode,
        });
        return orderService.workerRequest(serviceData);
    };
    /**
     * 필터 초기화
     */
    const resetFilterOption = () => {
        filterOption.value = {
            selectedHub: {
                type: 'HUB',
                id: 'ALL',
                hubId: 'ALL',
                hubName: '전체',
            },
            searchText: '',
        };
        updateFilteredItemList();
    };
    /**
     * 라이더 수행상황 조회
     */
    const getOrderByWorkerCode = async (workerCode) => {
        const res = await orderService.getOrderByWorkerCode({
            workerCode,
        });
        selectedWorkerOrderList.value = res;
    };
    return {
        selectedWorkerOrderList,
        filterOption,
        isDialogOpen,
        selectedWorker,
        distId,
        hubId,
        orderId,
        selectedOrder,
        fulfillment,
        setPopupData,
        getOrder,
        getFulfillment,
        allocateRequest,
        actionAllocate,
        filteredItemList,
        updateFilteredItemList,
        resetFilterOption,
        hubList,
        getOrderByWorkerCode,
    };
});
